
import React from 'react';
import { Star, ArrowLeft, ArrowRight } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    text: "Truecore delivered a custom tablet solution that revolutionized our warehouse management system. The hardware is robust, reliable, and perfectly tailored to our needs.",
    name: "Rajesh Sharma",
    position: "Operations Director, Global Logistics Inc.",
    rating: 5
  },
  {
    id: 2,
    text: "We've been using Truecore custom PCs for our design team for over 3 years. The performance is outstanding and their after-sales support is exceptional.",
    name: "Priya Patel",
    position: "Creative Director, DesignCraft Studios",
    rating: 5
  },
  {
    id: 3,
    text: "Their industrial tablets have transformed how we manage our manufacturing floor. The durability is impressive - they've survived drops, dust, and extreme conditions.",
    name: "Vikram Mehta",
    position: "Plant Manager, Precision Engineering Ltd.",
    rating: 5
  }
];

const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = React.useState(0);

  const nextTestimonial = () => {
    setActiveIndex((current) => (current + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((current) => (current - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-16 bg-muted">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          What Our Clients Say
        </h2>
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Testimonials */}
            <div className="overflow-hidden">
              <div 
                className="transition-all duration-500 ease-in-out flex"
                style={{ transform: `translateX(-${activeIndex * 100}%)` }}
              >
                {testimonials.map((testimonial) => (
                  <div key={testimonial.id} className="min-w-full px-4">
                    <div className="p-6 bg-card rounded-xl shadow-sm border border-border/50">
                      <div className="flex justify-center mb-4">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <Star 
                            key={i} 
                            className="text-primary fill-primary" 
                            size={24}
                          />
                        ))}
                      </div>
                      <p className="text-lg text-muted-foreground mb-4">
                        "{testimonial.text}"
                      </p>
                      <div className="font-medium">
                        <p className="text-foreground">{testimonial.name}</p>
                        <p className="text-muted-foreground">{testimonial.position}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Navigation controls */}
            {testimonials.length > 1 && (
              <div className="flex justify-center space-x-4 mt-8">
                <button 
                  onClick={prevTestimonial}
                  className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-colors"
                  aria-label="Previous testimonial"
                >
                  <ArrowLeft size={20} className="text-primary" />
                </button>
                <div className="flex space-x-2 items-center">
                  {testimonials.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => setActiveIndex(idx)}
                      className={`w-2.5 h-2.5 rounded-full transition-all ${
                        idx === activeIndex ? 'bg-primary w-6' : 'bg-primary/40'
                      }`}
                      aria-label={`Go to testimonial ${idx + 1}`}
                    />
                  ))}
                </div>
                <button 
                  onClick={nextTestimonial}
                  className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center hover:bg-primary/20 transition-colors"
                  aria-label="Next testimonial"
                >
                  <ArrowRight size={20} className="text-primary" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
